import { render } from "./ContactTasksDialog.vue?vue&type=template&id=2e804e23"
import script from "./ContactTasksDialog.vue?vue&type=script&lang=js"
export * from "./ContactTasksDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__